import React, { Component } from 'react';
import autosize from 'autosize';

class ExpandingTextarea extends Component {
  constructor(props) {
    super(props);
    this.timeoutId = null;
    this.rafId = null;
    this.textarea = null;
    this.update = this.update.bind(this);
    this.scheduleUpdate = this.scheduleUpdate.bind(this);
  }
  componentDidMount() {
    // Delay the autosize initialisation so that the autosize can
    // correctly calculate the height with the textarea value
    this.timeoutId = window.setTimeout(() => {
      autosize(this.textarea);

      // Listen to resize events so autosize can pick up updated CSS
      // values (like max-height) when breakpoints change.
      window.addEventListener('resize', this.scheduleUpdate);
    }, 100);
  }
  componentDidUpdate() {
    this.update();
  }
  componentWillUnmount() {
    autosize.destroy(this.textarea);
    window.clearTimeout(this.timeoutId);
    window.removeEventListener('resize', this.scheduleUpdate);
    if (this.rafId != null) {
      window.cancelAnimationFrame(this.rafId);
    }
  }
  // Coalesce resize bursts so autosize (which reads scrollHeight and writes
  // height, i.e. a layout read → write cycle) runs at most once per frame
  // instead of forcing a synchronous reflow on every resize event.
  scheduleUpdate() {
    if (this.rafId == null) {
      this.rafId = window.requestAnimationFrame(() => {
        this.rafId = null;
        this.update();
      });
    }
  }
  update() {
    autosize.update(this.textarea);
  }
  render() {
    return (
      <textarea
        {...this.props}
        ref={textarea => {
          this.textarea = textarea;
        }}
      />
    );
  }
}

export default ExpandingTextarea;
